module.exports = __webpack_public_path__ + "assets/img/kv-signup.0fcc7cba.png";